// Libs
import { room, live, tms, shopState, chat } from './distributor'
import { toast } from 'react-toastify'

// Constants
import {
  WS_EVENT_ROOM,
  WS_EVENT_CHAT,
  WS_EVENT_SHOP_STATE,
  WS_EVENT_TMS,
  WS_EVENT_LIVE_SHOW,
  LIVE_CODE,
  WS_EVENT_SYSTEM,
} from '@/constants/socketEvent'
import { ROLE } from '@/constants/role'

// Types
import { HandUpItemType, MicOnItemType } from '@/types/room'
import system from '@/methods/message/distributor/system'

export interface IMessage {
  message: {
    body: {
      code: 0 | 1 | 2 | 3 | 4 | 5 | 6
      type?: string
      key?: string
      value?: string | number | any
      from?: any
      content: any
      name?: string
      msg?: string
      canHandUp?: number
      handups?: HandUpItemType[]
      mics?: MicOnItemType[]
      status?: number
      uid?: string
      prod_name?: string
    }
    sid: number
    ssid: number
  }
  socketRef?: any
  roomId?: string
  userToken?: string
  targetToken?: string
  socketData?: any
  socket?: any
  rtcData?: any
  hostData?: any
  micOnList?: any[]
  isHost?: boolean
  memberData?: any
  roomData?: any
  connectStatus?: string
  notificationList?: any
  delayTime?: number
  memberInfoId?: string
  t?: any
  brandName?: string
  silentUserList?: string[]
}

export const handleMessageReceive = ({ message, socketData, memberData, socket, roomData, t, brandName, silentUserList }: IMessage) => {
  const { roomId, userToken, rtcData, hostData, targetToken, connectStatus, notificationList } = socketData
  const { role } = memberData

  const delayTime = roomData?.liveUrlInfo[0]?.delay

  const isHost = role === ROLE.HOST || role === ROLE.IT

  if (message.body && message.body.code > 0) {
    toast.error(`error: ${LIVE_CODE[message.body.code]}`)
    return
  }

  if (message.sid === WS_EVENT_SYSTEM.sid) {
    return system.action({ message, socket })
  } else if (message.sid === WS_EVENT_CHAT.sid) {
    return chat.action({ message, brandName, silentUserList })
  } else if (message.sid === WS_EVENT_SHOP_STATE.sid) {
    return shopState.action({ message, notificationList, roomData, userToken, t })
  } else if (message.sid === WS_EVENT_TMS.sid) {
    return tms.action({ message, hostData, isHost, connectStatus, rtcData })
  } else if (message.sid === WS_EVENT_ROOM.sid) {
    return room.action({ message, userToken, delayTime, brandName, silentUserList })
  } else if (message.sid === WS_EVENT_LIVE_SHOW.sid) {
    return live.action({ message, roomId, userToken, targetToken, socket, rtcData, hostData, isHost, connectStatus })
  }
}

export const handleRecv = (message: any, brandName?: string, silentUserList?: string[]) => {
  if (message.sid === WS_EVENT_CHAT.sid) {
    return chat.action({ message, brandName, silentUserList })
  }
}
